<nz-layout class="app-layout">
  <nz-sider class="menu-sidebar"
            nzCollapsible
            nzWidth="256px"
            [nzCollapsed]="isCollapsed"
            [nzTrigger]="null"
  >
    <div class="sidebar-logo">
      <a href="/">
        <img ngSrc="/logo-closia.svg" alt="logo" width="64" height="64" priority>
      </a>
    </div>
    @if (authService.token$ | async) {
      <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
        <li nz-menu-item nzMatchRouter>
          <a routerLink="/dashboard">
            <nz-icon nzType="dashboard" />
            <span>Tableau de bord</span>
          </a>
        </li>
        <li nz-menu-item nzMatchRouter>
          <a routerLink="/contacts">
            <nz-icon nzType="user" />
            <span>Contacts</span>
          </a>
        </li>
        <li nz-menu-item nzMatchRouter>
          <a routerLink="/visits">
            <nz-icon nzType="calendar" />
            <span>Visites</span>
          </a>
        </li>
        <li nz-menu-item nzMatchRouter>
          <a routerLink="/orders">
            <nz-icon nzType="shopping-cart" />
            <span>Commandes en cours</span>
          </a>
        </li>
        <li nz-menu-item nzMatchRouter>
          <a routerLink="/invoices">
            <nz-icon nzType="file-text" />
            <span>Factures</span>
          </a>
        </li>
        <li nz-menu-item nzMatchRouter>
          <a routerLink="/warranty-claims">
            <nz-icon nzType="pull-request" />
            <span>SAV</span>
          </a>
        </li>
        @if (authService.isAdminOrDirector$ | async) {
          <li nz-submenu nzTitle="Administration" nzIcon="setting">
            <ul>
              @if (authService.isAdmin$ | async) {
                <li nz-menu-item nzMatchRouter>
                  <a routerLink="/administration/data-import">
                    <span>Import</span>
                  </a>
                </li>
              }
              <li nz-menu-item nzMatchRouter>
                <a routerLink="/administration/users">
                  <span>Utilisateurs</span>
                </a>
              </li>
              @if (authService.isAdmin$ | async) {
                <li nz-menu-item nzMatchRouter>
                  <a routerLink="/administration/employers">
                    <span>Employeurs</span>
                  </a>
                </li>
              }
              @if (authService.isAdmin$ | async) {
                <li nz-menu-item nzMatchRouter>
                  <a routerLink="/administration/task-scheduler">
                    <span>Planificateur de tâches</span>
                  </a>
                </li>
                <li nz-menu-item nzMatchRouter>
                  <a routerLink="/administration/logs">
                    <span>Journaux</span>
                  </a>
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    }
    <!--
      At the foot of the menu rather than in the header: folding the menu is done once in a while,
      and the trigger was taking a prime place for it. Its own button rather than the sider's, so
      that a deliberate fold stays distinguishable from the one the window imposes (issue #49).
    -->
    <button
      class="sider-trigger"
      type="button"
      (click)="toggleMenu()"
      [attr.aria-label]="isCollapsed ? 'Déplier le menu' : 'Replier le menu'"
      [attr.aria-expanded]="!isCollapsed"
      nz-tooltip
      [nzTooltipTitle]="isCollapsed ? 'Déplier le menu' : 'Replier le menu'"
      nzTooltipPlacement="right"
    >
      <!-- Sans libellé : l'icône dit la même chose, et la place gagnée revient aux entrées du
           menu. L'infobulle et l'étiquette d'accessibilité portent le mot, dans les deux états. -->
      <nz-icon class="trigger" [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'" />
    </button>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="app-header" appStickyShadow>
        @if (authService.token$ | async) {
          <div class="header-search">
            <nz-input-wrapper>
              <nz-icon nzInputPrefix nzType="search" />
              <input
                #searchInput
                id="searchInput"
                type="text"
                nz-input
                placeholder="Rechercher..."
                nzSize="large"
                [formControl]="searchControl"
                [nzAutocomplete]="auto"
              />
              @if (isLoading) {
                <nz-icon nzInputSuffix nzType="loading" />
              }
            </nz-input-wrapper>
            <nz-autocomplete #auto (selectionChange)="onOptionSelected($event.nzValue)">
              @for (result of searchResults$ | async; track trackSearchResult($index, result)) {
                <nz-auto-option [nzValue]="result" [nzLabel]="result.name || ''">
                  <span>{{ result.name }}</span>
                  @if (result.type === ApplicationSearchSearchResultType.NUMBER_2) {
                    <span>&nbsp;</span>
                    <nz-tag nzColor="orange">Prospect</nz-tag>
                  }
                </nz-auto-option>
              }
            </nz-autocomplete>
          </div>
        }

        @if (authService.token$ | async) {
          <div class="header-right">
            <a nz-dropdown [nzDropdownMenu]="userMenu" nzPlacement="bottomRight">
              <nz-icon nzType="user" style="font-size: 20px; cursor: pointer; color: rgba(0, 0, 0, 0.85);"></nz-icon>
            </a>
            <nz-dropdown-menu #userMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="goToProfile()" (keydown)="onProfileKeydown($event)" tabindex="0" role="menuitem">
                  <nz-icon nzType="user" style="margin-right: 8px;"></nz-icon>
                  Mon profil
                </li>
                <li nz-menu-divider></li>
                <li nz-menu-item (click)="logout()" (keydown)="onLogoutKeydown($event)" tabindex="0" role="menuitem">
                  <nz-icon nzType="logout" style="margin-right: 8px;"></nz-icon>
                  Déconnexion
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        }
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
